export default "__VITE_ASSET__NStpHYL0__"